(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolongation/assets/javascripts/views/prolongation.js') >= 0) return;  svs.modules.push('/components/numbergames/prolongation/assets/javascripts/views/prolongation.js');

'use strict';

const {
  PROLONG_WAGERS_PARAMS
} = svs.numbergames.prolong_game.common.constants;
svs.numbergames.prolongation.views.Prolongation = Marionette.View.extend({
  className: 'numbergames-prolongation padding-xs-1 padding-md-h-2',
  regions: {
    prolongableWagersRegion: '#prolongableWagersRegion',
    prolongFooterRegion: '#prolongFooterRegion'
  },
  childViewEventPrefix: false,
  childViewTriggers: {
    loadMoreWagers: 'childview:loadMoreWagers',
    prolongWager: 'prolongWager'
  },
  collectionEvents: {
    'wagers:fetched': 'renderFooter'
  },
  template() {
    return svs.numbergames.prolongation.templates.prolongation();
  },
  initialize() {
    svs.numbergames.prolongation.logger.debug('views.Prolongation Initialized with options', this.options);
    this.collection = new svs.numbergames.prolongation.collections.ProlongableWagers(null, {
      productId: this.options.productId,
      syndicates: this.options.syndicates,
      oldestProlongableDraw: this.options.oldestProlongableDraw
    });
    this.collection.fetch({
      success: this.renderWagers,
      context: this
    });
    const payParam = svs.utils.paramHandler.get({
      key: 'pay'
    }).value;
    const wagerIdParam = svs.utils.paramHandler.get({
      key: 'wagerid'
    }).value;
    if (payParam && wagerIdParam) {
      let onDoneCb;
      svs.numbergames.pay_numbergames.makePayment({
        wagerId: wagerIdParam,
        onDoneCb,
        onSuccessCb: () => {
          const model = this.collection.get(wagerIdParam);
          if (model) {
            model.set({
              isProlonged: true
            });
          }
        }
      });
    }
    const prolongWagerId = svs.utils.paramHandler.get({
      key: PROLONG_WAGERS_PARAMS.prepId
    }).value;
    if (prolongWagerId) {
      this.collection.updateWager(prolongWagerId, {
        parseFinishedWager: true,
        success: model => this.triggerMethod('prolongWager', model)
      });
    }
  },
  renderWagers() {
    this.showChildView('prolongableWagersRegion', new svs.numbergames.prolongation.views.Wagers({
      collection: this.collection,
      childViewOptions: {
        productName: svs.numbergames.productMapping.getProductName(this.getOption('productId'))
      }
    }));
  },
  renderFooter() {
    if (this.collection.hasMoreItems) {
      this.showChildView('prolongFooterRegion', {
        ui: {
          loadMoreBtn: '.js-load-more-btn'
        },
        triggers: {
          'click @ui.loadMoreBtn': 'loadMoreWagers'
        },
        template: () => svs.ui.button.partials.button({
          class: 'js-load-more-btn',
          title: 'Ladda fler +'
        })
      });
    } else if (this.collection.length) {
      this.showChildView('prolongFooterRegion', '<span class="f-500">Du har inga fler avgjorda spel.</span>');
    }
  },
  onChildviewLoadMoreWagers() {
    this.getRegion('prolongFooterRegion').reset();
    this.collection.fetch();
  },
  onProlongWager(child) {
    const target = document.getElementById('prolongGameRegion');
    if (target) {
      const model = child.model || child;
      ReactDOM.render(
      React.createElement(svs.numbergames.prolong_game.ProlongGame, {
        wager: model.get('originalApiWager'),
        onOpenClose: _ref => {
          let {
            isOpen
          } = _ref;
          return !isOpen && ReactDOM.unmountComponentAtNode(target);
        },
        onSuccessCb: () => model.set('isProlonged', true),
        onboardingWidgetArea: "lottoFullscreenWidgetArea"
      }), target);
    }
  }
});

 })(window);